export const EDINBURGHCLLRS = [
  {
    name: "Kevin Lang",
    party: "LibDem",
    ward: "Almond",
    email: "kevin.lang@edinburgh.gov.uk",
    twitter: "@kevin_lang",
  },
  {
    name: "Norman Work",
    party: "SNP",
    ward: "Almond",
    email: "norman.work@edinburgh.gov.uk",
    twitter: "@CllrNormanWork",
  },
  {
    name: "Louise Young",
    party: "LibDem",
    ward: "Almond",
    email: "louise.young@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Lewis Younie",
    party: "LibDem",
    ward: "Almond",
    email: "Cllr.Lewis.Younie@edinburgh.gov.uk",
    twitter: "@Lewis_Younie",
  },
  {
    name: "Maragret Anna Graham",
    party: "Labour",
    ward: "City Centre",
    email: "Cllr.Margaret.Graham@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Finlay McFarlane",
    party: "SNP",
    ward: "City Centre",
    email: "Cllr.Finlay.Mcfarlane@edinburgh.gov.uk",
    twitter: "@FinlayMcF",
  },
  {
    name: "Claire Miller",
    party: "Green",
    ward: "City Centre",
    email: "C.Miller@edinburgh.gov.uk",
    twitter: "@CllrCMiller",
  },
  {
    name: "Joanna Mowat",
    party: "Tory",
    ward: "City Centre",
    email: "cllr.jo.mowat@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Scott Arthur",
    party: "Labour",
    ward: "Colinton/Fairmilehead",
    email: "Scott.Arthur@edinburgh.gov.uk",
    twitter: "@CllrScottArthur",
  },
  {
    name: "Marco Biagi",
    party: "SNP",
    ward: "Colinton/Fairmilehead",
    email: "Cllr.Marco.Biagi@edinburgh.gov.uk",
    twitter: "@MarcoGBiagi",
  },
  {
    name: "Jason Rust",
    party: "Tory",
    ward: "Colinton/Fairmilehead",
    email: "jason.rust@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Alan Beal",
    party: "LibDem",
    ward: "Corstorphine/Murrayfield",
    email: "Cllr.Alan.Beal@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Euan Davidson",
    party: "LibDem",
    ward: "Corstorphine/Murrayfield",
    email: "Cllr.Euan.Davidson@edinburgh.gov.uk",
    twitter: "@euandavidson",
  },
  {
    name: "Frank Ross",
    party: "SNP",
    ward: "Corstorphine/Murrayfield",
    email: "frank.ross@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Danny Aston",
    party: "SNP",
    ward: "Craigentinny/Duddingston",
    email: "Cllr.Danny.Aston@edinburgh.gov.uk",
    twitter: "@DAstonSNP",
  },
  {
    name: "Joan Griffiths",
    party: "Labour",
    ward: "Craigentinny/Duddingston",
    email: "joan.griffiths@edinburgh.gov.uk",
    twitter: "@joan_griffiths",
  },
  {
    name: "Alex Staniforth",
    party: "Green",
    ward: "Craigentinny/Duddingston",
    email: "alex.staniforth@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Iain Whyte",
    party: "Tory",
    ward: "Craigentinny/Duddingston",
    email: "iain.whyte@edinburgh.gov.uk",
    twitter: "@CllrWhyte",
  },
  {
    name: "Robert Aldridge",
    party: "LibDem",
    ward: "Drum Brae/Gyle",
    email: "robert.aldridge@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Euan Hyslop",
    party: "SNP",
    ward: "Drum Brae/Gyle",
    email: "Cllr.Euan.Hyslop@edinburgh.gov.uk",
    twitter: "@EuanHyslop",
  },
  {
    name: "Edward Thornley",
    party: "LibDem",
    ward: "Drum Brae/Gyle",
    email: "Cllr.Edward.Thornley@edinburgh.gov.uk",
    twitter: "@edjthornley",
  },
  {
    name: "Cammy Day",
    party: "Labour",
    ward: "Forth",
    email: "Cammy.Day@edinburgh.gov.uk",
    twitter: "@cllrcammyday",
  },
  {
    name: "Sanne Dijkstra-Downie",
    party: "LibDem",
    ward: "Forth",
    email: "Cllr.Sanne.Dijkstra-Downie@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Stuart Dobbin",
    party: "SNP",
    ward: "Forth",
    email: "Cllr.Stuart.Dobbin@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Kayleigh O'Neill",
    party: "Green",
    ward: "Forth",
    email: "Cllr.Kayleigh.ONeill@edinburgh.gov.uk",
    twitter: "@KayleighFONeill",
  },
  {
    name: "Christopher Cowdy",
    party: "Tory",
    ward: "Fountainbridge/Craiglockhart",
    email: "Cllr.Christopher.Cowdy@edinburgh.gov.uk",
    twitter: "@CouncillorCowdy",
  },
  {
    name: "David Key",
    party: "SNP",
    ward: "Fountainbridge/Craiglockhart",
    email: "david.key@edinburgh.gov.uk",
    twitter: "@davidfkey",
  },
  {
    name: "Val Walker",
    party: "Labour",
    ward: "Fountainbridge/Craiglockhart",
    email: "Cllr.Val.Walker@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Jule Bandel",
    party: "Green",
    ward: "Inverleith",
    email: "Cllr.Jule.Bandel@edinburgh.gov.uk",
    twitter: "@julebandel",
  },
  {
    name: "Max Mitchell",
    party: "Tory",
    ward: "Inverleith",
    email: "max.mitchell@edinburgh.gov.uk",
    twitter: "@maxmitchell91",
  },
  {
    name: "Vicky Nicolson",
    party: "SNP",
    ward: "Inverleith",
    email: "Cllr.Vicky.Nicolson@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Hal Osler",
    party: "LibDem",
    ward: "Inverleith",
    email: "hal.osler@edinburgh.gov.uk",
    twitter: "@HalOsler",
  },
  {
    name: "Chas Booth",
    party: "Green",
    ward: "Leith",
    email: "chas.booth@edinburgh.gov.uk",
    twitter: "@CllrChasBooth",
  },
  {
    name: "Katrina Faccenda",
    party: "Labour",
    ward: "Leith",
    email: "Cllr.Katrina.Faccenda@edinburgh.gov.uk",
    twitter: "@KatrinaFaccenda",
  },
  {
    name: "Adam Nols-McVey",
    party: "SNP",
    ward: "Leith",
    email: "adam.mcvey@edinburgh.gov.uk",
    twitter: "@adamrnolsmcvey",
  },
  {
    name: "Jack Caldwell",
    party: "LibDem",
    ward: "Leith Walk",
    email: "Cllr.Jack.Caldwell@edinburgh.gov.uk",
    twitter: "@JackRMCaldwell",
  },
  {
    name: "James Dalgleish",
    party: "Labour",
    ward: "Leith Walk",
    email: "Cllr.James.Dalgleish@edinburgh.gov.uk",
    twitter: "@james_dalgleish",
  },
  {
    name: "Amy McNeese-Mechan",
    party: "SNP",
    ward: "Leith Walk",
    email: "cllr.amy.mcneese-mechan@edinburgh.gov.uk",
    twitter: "@AMcNeeseMechan",
  },
  {
    name: "Susan Rae",
    party: "Green",
    ward: "Leith Walk",
    email: "susan.rae@edinburgh.gov.uk",
    twitter: "@susan4leithwalk",
  },
  {
    name: "Phil Doggart",
    party: "Tory",
    ward: "Liberton/Gilmerton",
    email: "phil.doggart@edinburgh.gov.uk",
    twitter: "@PhilipDoggart",
  },
  {
    name: "Lesley Macinnes",
    party: "SNP",
    ward: "Liberton/Gilmerton",
    email: "lesley.macinnes@edinburgh.gov.uk",
    twitter: "@lmacinnessnp",
  },
  {
    name: "Lezley Marion Cameron",
    party: "Labour",
    ward: "Liberton/Gilmerton",
    email: "lezleymarion.cameron@edinburgh.gov.uk",
    twitter: "@lezleymarion",
  },
  {
    name: "Martha Mattos Coelho",
    party: "SNP",
    ward: "Liberton/Gilmerton",
    email: "Cllr.Martha.MattosCoelho@edinburgh.gov.uk",
    twitter: "@MthMttCoe",
  },
  {
    name: "Marie-Clair Munro",
    party: "Tory",
    ward: "Morningside",
    email: "Cllr.Marie-Clair.Munro@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Ben Parker",
    party: "Green",
    ward: "Morningside",
    email: "Cllr.Ben.Parker@edinburgh.gov.uk",
    twitter: "@CllrBenParker",
  },
  {
    name: "Neil Ross",
    party: "LibDem",
    ward: "Morningside",
    email: "neil.ross@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Mandy Watt",
    party: "Labour",
    ward: "Morningside",
    email: "mandy.watt@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Graeme Bruce",
    party: "Tory",
    ward: "Pentland Hills",
    email: "graeme.bruce@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Neil Gardiner",
    party: "SNP",
    ward: "Pentland Hills",
    email: "neil.gardiner@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Fiona Glasgow",
    party: "SNP",
    ward: "Pentland Hills",
    email: "Cllr.Fiona.Glasgow@edinburgh.gov.uk",
    twitter: "@FionaCllr",
  },
  {
    name: "Stephen Jenkinson",
    party: "Labour",
    ward: "Pentland Hills",
    email: "Cllr.Stephen.Jenkinson@edinburgh.gov.uk",
    twitter: "@sjenkinson76",
  },
  {
    name: "Kate Campbell",
    party: "SNP",
    ward: "Portobello/Craigmillar",
    email: "kate.campbell@edinburgh.gov.uk",
    twitter: "@KateC_SNP",
  },
  {
    name: "Tim Jones",
    party: "Tory",
    ward: "Portobello/Craigmillar",
    email: "Cllr.Tim.Jones@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Jane Meagher",
    party: "Labour",
    ward: "Portobello/Craigmillar",
    email: "Cllr.Jane.Meagher@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Alys Mumford",
    party: "Green",
    ward: "Portobello/Craigmillar",
    email: "Cllr.Alys.Mumford@edinburgh.gov.uk",
    twitter: "@AlysGreens",
  },
  {
    name: "Denis Dixon",
    party: "SNP",
    ward: "Sighthill/Gorgie",
    email: "denis.dixon@edinburgh.gov.uk",
    twitter: "@DenisDixonSNP",
  },
  {
    name: "Catherine Fullerton",
    party: "SNP",
    ward: "Sighthill/Gorgie",
    email: "cathy.fullerton@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Dan Heap",
    party: "Green",
    ward: "Sighthill/Gorgie",
    email: "Cllr.Dan.Heap@edinburgh.gov.uk",
    twitter: "@CllrDanHeap",
  },
  {
    name: "Ross McKenzie",
    party: "Labour",
    ward: "Sighthill/Gorgie",
    email: "Cllr.Ross.Mckenzie@edinburgh.gov.uk",
    twitter: "@rsmcksg",
  },
  {
    name: "Steve Burgess",
    party: "Green",
    ward: "Southside/Newington",
    email: "Steve.Burgess@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Pauline Flannery",
    party: "LibDem",
    ward: "Southside/Newington",
    email: "Cllr.Pauline.Flannery@edinburgh.gov.uk",
    twitter: "none",
  },
  {
    name: "Simita Kumar",
    party: "SNP",
    ward: "Southside/Newington",
    email: "Cllr.Simita.Kumar@edinburgh.gov.uk",
    twitter: "@SimitaSKumar",
  },
  {
    name: "Tim Pogson",
    party: "Labour",
    ward: "Southside/Newington",
    email: "Cllr.Tim.Pogson@edinburgh.gov.uk",
    twitter: "none",
  },
];
